const NewPayment = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
        {...props}
    >
        <path d="M4.4 16.395 3.356 15.35l9.84-9.85H4.25V4h11.5v11.5h-1.5V6.554l-9.85 9.84Zm14 3.205V22h1.2v-2.4H22v-1.2h-2.4V16h-1.2v2.4H16v1.2h2.4Z" />
    </svg>
);

export default NewPayment;
